import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings } from '../enums/app-settings.enum';
import { EnvironmentConfigurations } from '../models/EnvironmentConfigurations';

@Injectable({
providedIn: 'root'
})
export class ApplicationInitializationService {

    environmentConfig: EnvironmentConfigurations;

    constructor(private http: HttpClient) { }

    initializeApp() {
        return this.http.get(environment?.B2C_URL + '/getEnvironmentConfigurations.service').toPromise()
            .then(async (response: any) => {
                this.environmentConfig = response?.hybridEnvironmentConfigurations?.HYBRID_DYNAMIC_CONFIGS;
                this.environmentConfig.B2C_PRORATA_TOTAL_VALUE = response?.hybridEnvironmentConfigurations?.B2C_PRORATA_TOTAL_VALUE;
                this.environmentConfig.ADDONS_DEFAULT_CATEGORIES = response?.hybridEnvironmentConfigurations?.ADDONS_DEFAULT_CATEGORIES;
                this.environmentConfig.ROAMING_FREQUENTRLY_VISITED_COUNTRIES = response?.hybridEnvironmentConfigurations?.ROAMING_FREQUENTRLY_VISITED_COUNTRIES ?? [];
                this.environmentConfig.PARENTAL_CONTROL_ADDONS = response?.hybridEnvironmentConfigurations?.PARENTAL_CONTROL_ADDONS;
                this.environmentConfig.MOBILE_VIEW_ADDONS_TABS_GENERAL = response?.hybridEnvironmentConfigurations?.MOBILE_VIEW_ADDONS_TABS_GENERAL;
                this.environmentConfig.MOBILE_VIEW_ADDONS_TABS_ELIFE = response?.hybridEnvironmentConfigurations?.MOBILE_VIEW_ADDONS_TABS_ELIFE;
                this.environmentConfig.ESHOP_ADDONS_CATEGORIES = response?.hybridEnvironmentConfigurations?.ESHOP_ADDONS_CATEGORIES;
                this.environmentConfig.ERROR_CODES= response?.hybridEnvironmentConfigurations?.ERROR_CODES;
                this.environmentConfig.CMS_URL_NEW_FRAGMENTPATH = response?.hybridEnvironmentConfigurations?.CMS_URL_NEW_FRAGMENTPATH;
                this.environmentConfig.ERROR_CODES = response?.hybridEnvironmentConfigurations?.ERROR_CODES;
                this.environmentConfig.ADDONS_VAT_ELIGIBILITY_ACCOUNT_TYPES = response?.hybridEnvironmentConfigurations?.ADDONS_VAT_ELIGIBILITY_ACCOUNT_TYPES;
                this.environmentConfig.NORTH_LADDER_URL = response?.hybridEnvironmentConfigurations?.NORTH_LADDER_URL;
                this.environmentConfig.NORTH_LADDER_URL_AR = response?.hybridEnvironmentConfigurations?.NORTH_LADDER_URL_AR;
                this.environmentConfig.ARENA_PRO_PRODUCT_CATEGORY = response?.hybridEnvironmentConfigurations?.ARENA_PRO_PRODUCT_CATEGORY;
                this.environmentConfig.CNAP_EMAIL = response?.hybridEnvironmentConfigurations?.CNAP_EMAIL;
                this.environmentConfig.HYBRID_PLANS_CONTENT_PASS_ID = response?.hybridEnvironmentConfigurations?.HYBRID_PLANS_CONTENT_PASS_ID;
                this.environmentConfig.MAX_PASS_COUNT_ALLOWED = response?.hybridEnvironmentConfigurations?.MAX_PASS_COUNT_ALLOWED;
                this.environmentConfig.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW = response?.hybridEnvironmentConfigurations?.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW;
                this.environmentConfig.CONTENT_PASSES_CATEGORIES = response?.hybridEnvironmentConfigurations?.CONTENT_PASSES_CATEGORIES;
                this.environmentConfig.ENABLE_OTP_AUTHERIZATION_ADDONS = response?.hybridEnvironmentConfigurations?.ENABLE_OTP_AUTHERIZATION_ADDONS;
            })
            .catch((error) => {
                // When service fails, get the configurations from the backup
                this.prepareConfigurationBackup();

            });
    }

    prepareConfigurationBackup() {
        this.environmentConfig = new EnvironmentConfigurations();
        this.environmentConfig.CMS_HOST = environment?.CMS_HOST;
        this.environmentConfig.GTM = environment?.GTM;
        this.environmentConfig.ADOBE_SCRIPT = AppSettings.ADOBE_BACKUP_SCRIPT;
        this.environmentConfig.CARAMEL_CATEGORY = AppSettings.CARAMEL_CATEGORY;
        this.environmentConfig.MAP_KEY = environment?.MAP_KEY;
        this.environmentConfig.CMS_URL_NEW_FRAGMENTPATH = AppSettings.CMS_URL_NEW_FRAGMENTPATH;
        this.environmentConfig.NORTH_LADDER_URL = AppSettings?.NORTH_LADDER_URL;
        this.environmentConfig.NORTH_LADDER_URL_AR = AppSettings?.NORTH_LADDER_URL_AR;
        this.environmentConfig.ARENA_PRO_PRODUCT_CATEGORY = AppSettings.ARENA_PRO_PRODUCT_CATEGORY;
        this.environmentConfig.CNAP_EMAIL = AppSettings?.CNAP_EMAIL;
        this.environmentConfig.HYBRID_PLANS_CONTENT_PASS_ID = AppSettings.HYBRID_PLANS_CONTENT_PASS_ID;
        this.environmentConfig.MAX_PASS_COUNT_ALLOWED = AppSettings.MAX_PASS_COUNT_ALLOWED;
        this.environmentConfig.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW = AppSettings.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW;
        this.environmentConfig.CONTENT_PASSES_CATEGORIES = AppSettings?.CONTENT_PASSES_CATEGORIES;
        this.environmentConfig.ENABLE_OTP_AUTHERIZATION_ADDONS = AppSettings.ENABLE_OTP_AUTHERIZATION_ADDONS;
    }

}
